import React, { useMemo, useState } from 'react'

import { ImageDescriptionSlideoutDetails } from '@application/Interfaces/Features/ImageDescriptionSlideout/ImageDescriptionSlideoutDetails/ImageDescriptionSlideoutDetails'
import { ImageDescriptionSlideoutFooter } from '@application/Interfaces/Features/ImageDescriptionSlideout/ImageDescriptionSlideoutFooter/ImageDescriptionSlideoutFooter'
import { ImageDescriptionSlideoutItem } from '@application/Interfaces/Features/ImageDescriptionSlideout/ImageDescriptionSlideoutItem/ImageDescriptionSlideoutItem'
import {
    nextClickHandler,
    prevClickHandler,
    toggleSlideOut,
} from '@application/Interfaces/Features/ImageDescriptionSlideout/utils'
import { ImageDescriptionSlideoutType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import { Link, TitleSection } from './ImageDescriptionSlideout.styled'

export const ImageDescriptionSlideout = ({
    imageDescriptionSlideoutTitle,
    subtitle,
    previousLabel,
    nextLabel,
    boxes,
}: ImageDescriptionSlideoutType): JSX.Element => {
    const [activeIndex, setActiveIndex] = useState<number>(0)
    const [openSlide, setOpenSlide] = useState(false)

    const members = useMemo(() => boxes.filter((box) => !box.otherLink), [boxes])
    const joinOurTeamMembers = useMemo(() => boxes.filter((box) => box.otherLink), [boxes])

    const activeMember = useMemo(() => members[activeIndex], [members, activeIndex])
    const isPreviousDisabled = useMemo(() => activeIndex === 0, [activeIndex])
    const isNextDisabled = useMemo(() => activeIndex === members.length - 1, [members, activeIndex])

    return (
        <TitleSection title={imageDescriptionSlideoutTitle} subtitle={subtitle}>
            <Grid container columnSpacing={6} rowSpacing={{ xs: 10, md: 20 }}>
                {members.map((member, index) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={member.title}
                        onClick={toggleSlideOut(index, setActiveIndex, true, setOpenSlide)}
                    >
                        <ImageDescriptionSlideoutItem {...member} />
                    </Grid>
                ))}
                {joinOurTeamMembers.map((member, index) => (
                    <Grid item xs={12} sm={6} md={4} key={member.title}>
                        <Link to={member.otherLink as string}>
                            <ImageDescriptionSlideoutItem {...member} />
                        </Link>
                    </Grid>
                ))}
            </Grid>
            {activeMember && (
                <ImageDescriptionSlideoutDetails
                    isOpen={openSlide}
                    title={activeMember.title}
                    subtitle={activeMember.subtitle}
                    image={activeMember.image}
                    description={activeMember.description}
                    linkedinProfile={activeMember.linkedinProfile}
                    onClose={toggleSlideOut(activeIndex, setActiveIndex, false, setOpenSlide)}
                    Footer={() => (
                        <ImageDescriptionSlideoutFooter
                            onPrevClick={prevClickHandler(activeIndex, setActiveIndex)}
                            onNextClick={nextClickHandler(activeIndex, setActiveIndex)}
                            prevDisabled={isPreviousDisabled}
                            nextDisabled={isNextDisabled}
                            previousLabel={previousLabel}
                            nextLabel={nextLabel}
                        />
                    )}
                />
            )}
        </TitleSection>
    )
}
